import { Box, Button, Checkbox, Select, Typography } from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { DropdownFilterContainer, StyledMenuItem, StyledSelect } from "./Atom"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { setSelectedProvidersGroups } from "../../../redux/slices/providersSlice"
import { colors } from "../../../../styles/commonStyles"

const ProvidersHeaderBasicDropdownMultiFilter = (props: any) => {
  const {
    id,
    disabled,
    handleFilter,
    placeholder,
    value,
    filterData,
    headerLabel,
    isAllSelected,
    valueKey,
    useStringMatch,
  } = props
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const handleClose = () => {
    setOpen(false)
  }
  const selectedProvidersGroups = useSelector((state: any) => {
    return state.providers.selectedProvidersGroups
  })
  // console.log("value", value)
  // const isAllSelected =
  //   filterData?.length > 0 && value?.length >= filterData?.length
  //   console.log("selectedProvidersGroups", selectedProvidersGroups)
  return (
    <DropdownFilterContainer>
      <Typography fontSize={10}>{headerLabel}</Typography>
      <Select
        id={id}
        value={value}
        open={open}
        onClose={handleClose}
        onOpen={() => setOpen(true)}
        labelId="demo-multiple-name-label"
        multiple
        disabled={disabled}
        onChange={handleFilter}
        IconComponent={ExpandMoreIcon}
        displayEmpty
        renderValue={(selected: any): any =>
          value?.length === 0 ? (
            <Box>{placeholder}</Box>
          ) : (
            <Box sx={{ overflow: "hidden" }}>
              {selected?.map((item: any, index: any) =>
                index + 1 === selected?.length
                  ? `${item?.label}`
                  : `${item?.label}, `,
              )}
            </Box>
          )
        }
        sx={{
          height: "40px",
          width: "200px",
          fontSize: "14px",
          marginTop: "5px",
          backgroundColor: "#FFFFFF",
        }}
        MenuProps={{
          sx: {
            width: "180px",
            maxHeight: "550px",
            my: 1,
          },
        }}
      >
        <StyledMenuItem
          sx={{ width: "180px", gap: "10px", padding: "10px 10px" }}
        >
          <Checkbox
            name="select-checkbox"
            checked={isAllSelected}
            sx={{ p: 0 }}
          />
          Select All
        </StyledMenuItem>
        {filterData?.length ? (
          filterData?.map((item: any, index: number) => (
            <StyledMenuItem
              key={index}
              value={item}
              sx={{
                width: "180px",
                gap: "10px",
                padding: "10px 10px",
              }}
            >
              <Checkbox checked={
                useStringMatch
                  ? value?.some((v: any) => v === item)           // region — plain string comparison
                  : value?.some((v: any) => v[valueKey] === item[valueKey])  // group/office — object comparison
                }  
                sx={{ p: 0 }} />
              {item?.label}
            </StyledMenuItem>
          ))
        ) : (
          <StyledMenuItem disabled={true}>No Data</StyledMenuItem>
        )}
        <Box
          sx={{
            position: "sticky",
            bottom: "0px",
            minHeight: "50px",
            backgroundColor: "#fff",
            marginBottom: -1,
            pb: "8px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            fullWidth
            disableFocusRipple
            key={"apply-close"}
            variant="contained"
            onClick={handleClose}
            sx={{
              height: "40px",
              width: "180px",
              textTransform: "none",
              fontWeight: "bold",
              justifyContent: "center",

              mt: "5px",
              borderWidth: 0,
              backgroundColor: colors.primaryBlue,
            }}
          >
            Apply
          </Button>
        </Box>
      </Select>
    </DropdownFilterContainer>
    // <DropdownFilterContainer>
    //   <Typography fontSize={10}>{headerLabel}</Typography>

    //   <StyledSelect
    //     labelId="demo-multiple-name-label"
    //     multiple
    //     id={id}
    //     value={value}
    //     onChange={handleFilter}
    //     disabled={disabled}
    //     IconComponent={ExpandMoreIcon}
    //     displayEmpty
    //     renderValue={(selected: any): any =>
    //       value?.length ? (
    //         <Box sx={{ overflow: "hidden" }}>
    //           {selected?.map((item: any, index: any) =>
    //             index + 1 === selected?.length
    //               ? `${item?.label}`
    //               : `${item?.label}, `,
    //           )}
    //         </Box>
    //       ) : (
    //         <Box>{placeholder}</Box>
    //       )
    //     }
    //   >
    //     <StyledMenuItem onClick={() => {}}>
    //       <Checkbox checked={isAllSelected} />
    //       Select All
    //     </StyledMenuItem>
    //     {filterData?.length ? (
    //       filterData?.map((item: any, index: number) => (
    //         <StyledMenuItem key={index} value={item}>
    //           <Checkbox checked={value.indexOf(item) > -1} />
    //           {item?.label}
    //         </StyledMenuItem>
    //       ))
    //     ) : (
    //       <StyledMenuItem disabled={true}>No Data</StyledMenuItem>
    //     )}
    //   </StyledSelect>
    // </DropdownFilterContainer>
  )
}

export default ProvidersHeaderBasicDropdownMultiFilter
